import React, { FC } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useNewBookingDefaultValues } from '../../booking-steps/details/hooks/useDefaultValues';
import { useDetailsPageParentLink } from '../../booking-steps/details/hooks/useDetailsPageParentLink';
import { useHandleSubmitNewBooking } from '../../booking-steps/details/hooks/useHandleSubmitNewBooking';
import { usePrefetchPaymentUrl } from '../../booking-steps/details/hooks/usePrefetchPaymentUrl';
import { useBookingDateValidation } from '../../booking-steps/shared/validation/useBookingDateValidation';
import { useParkingProductValidation } from '../../booking-steps/shared/validation/useParkingProductValidation';
import { useStateValidation } from '../../booking-steps/shared/validation/useStateValidation';
import { Details } from '../../booking-steps/details/Details';
import { BookingPageLayout } from '../shared/BookingPageLayout';
import { useNewBookingStore } from '../../../domain/booking/stores/useNewBookingsStore';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { useCreateEmailSuggestionStore } from '../../../domain/email-validation/stores/useCreateEmailSuggestionStore';

export const NewBookingDetailsPage: FC = () => {
	const { t } = useTranslation();
	const { parentUrl, parentTitle } = useDetailsPageParentLink();
	const { url: nextUrl } = usePrefetchPaymentUrl();
	const { handleSubmit } = useHandleSubmitNewBooking(nextUrl);
	const { booking, originalBooking } = useNewBookingStore();
	const emailSuggestionStore = useCreateEmailSuggestionStore();
	const parkingOptionsUrl = useUrlForPageId(
		ParkingPageId.NewBookingAvailability,
	);

	useStateValidation([
		useBookingDateValidation(),
		useParkingProductValidation(),
	]);

	const defaultValues = useNewBookingDefaultValues();

	return (
		<BookingPageLayout
			parentUrl={parentUrl}
			parentTitle={parentTitle}
			title={t('web_parking_details_header')}
		>
			<Details
				originalBooking={originalBooking}
				booking={booking}
				finalSubmitHandler={handleSubmit}
				defaultValues={defaultValues}
				submitButtonText={t('web_parking_details_submit_button')}
				changeButtonUrl={parkingOptionsUrl}
				emailSuggestionStore={emailSuggestionStore}
			/>
		</BookingPageLayout>
	);
};
